import { Component } from '@angular/core';

@Component({
  templateUrl: 'logout-layout.component.html',
  styleUrls: ['logout-layout.component.scss'],
})
export class LogoutLayoutComponent {}
